/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * moovy-saas-api
 * OpenAPI spec version: 1.0.0
 */
import type { Cuid } from './cuid'

export interface VideoTag {
  updatedAt: string
  createdAt: string
  order: number
  name: string
  tenantId: Cuid
  id: Cuid
}
